define('modules/page_listing/views/listing_item',['require','exports','module','base/layout','backbone','./tags_view','env','common/models/appstate','ldsh!../templates/listing_item'],function (require, exports, module) {
  'use strict';

  var Layout = require('base/layout'),
    Backbone = require('backbone'),
    TagListCollectionView = require('./tags_view'),
    config = require('env'),
    AppState = require('common/models/appstate');

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  module.exports = Layout.extend({
    regions: {
      pageTags: '.js-page-tags',
    },
    className: 'ed-box-item ed-box-item-page',
    template: require('ldsh!../templates/listing_item'),

    triggers: {
      'click .js-delete': 'page:delete',
      'click .js-publish': 'page:publish',
      'click .js-unpublish': 'page:unpublish',
      'click .js-duplicate': 'page:duplicate',
      'click .js-update': 'page:update',
      'click .js-integration': 'navigate:integration',
      'click .js-tag': 'tag:add',
      'click .js-copy-to': 'page:copy',
      'click .js-hide': 'page:hide',
      'click .js-display': 'page:display',
    },

    initialize: function (options) {
      this.viewState = new Backbone.Model();
      this.$pageTags.show(new TagListCollectionView({ collection: this.model.tags }));
      this.listenTo(this.model, 'removed:tag', _.bind(this.trigger, this, 'tag:reload'));
    },

    helpers: function () {
      var safeName = escapeHtml(this.model.get('name')),
        previewUrl = this.model.get('previewUrl'),
        fullUrl = this.model.get('full_url');

      if (safeName.length > 100) {
        safeName = safeName.substr(0, 99) + '...';
      }

      if (fullUrl.indexOf('//') === 0) {
        fullUrl = 'https:' + fullUrl;
      }

      this._updateViewState();

      var updatedAt = new Date(this.model.get('updated_at') * 1000),
        lastUpdatedDate = [
          updatedAt.getDate(),
          updatedAt.getMonth() + 1,
          updatedAt.getFullYear(),
        ].join('/');

      if (previewUrl) {
        previewUrl = config.apiHost + '/img/assets/' + previewUrl + '?' + Math.random() * 10;
      } else {
        previewUrl = '/app/img/ex-mini.jpg';
      }

      return {
        escapedName: safeName,
        state: this.viewState.toJSON(),
        previewUrl: previewUrl,
        fullUrl: fullUrl,
        lastUpdatedDate: lastUpdatedDate,
        isNewFree: AppState.isAdminFreemium(),
      };
    },

    onRender: function () {
      this.$el.i18n();
    },

    _updateViewState: function () {
      //page status icon class
      if (!!this.model.get('published')) {
        if (!!this.model.get('outdated')) {
          //update pending
          this.viewState.set('icon', 'ed-icon-time');
          this.viewState.set('class', 'ed-pend-act');
          this.viewState.set('text', 'pageListing.statusOutdated');
        } else {
          //up to date
          this.viewState.set('icon', 'ed-icon-publish');
          this.viewState.set('class', 'ed-published');
          this.viewState.set('text', 'pageListing.statusPublished');
        }
      } else {
        //non published
        this.viewState.set('icon', 'ed-icon-draft');
        this.viewState.set('class', 'ed-no-published');
        this.viewState.set('text', 'pageListing.statusUnpublished');
      }
    },
  });
});

